import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { FiSave, FiArrowLeft, FiX, FiPlus } from 'react-icons/fi';
import api from '../../services/api';
import './CadastroReuniao.css';

const MODELOS_PREDEFINIDOS = [
  { titulo: 'Reunião de jovens', descricao: 'Reunião com os jovens da congregação' },
  { titulo: 'Reunião dos auxiliares', descricao: 'Reunião dos auxiliares ministeriais' },
  { titulo: 'Reunião da administração', descricao: 'Reunião da administração da congregação' },
  { titulo: 'Reunião dos colaboradores do espaço bíblico infantil', descricao: 'Reunião dos colaboradores do espaço bíblico infantil' }
];

const CadastroReuniao = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [colaboradores, setColaboradores] = useState([]);
  const [cargos, setCargos] = useState([]);
  const [loadingData, setLoadingData] = useState(true);
  const [participantesSelecionados, setParticipantesSelecionados] = useState([]);
  const [cargosSelecionados, setCargosSelecionados] = useState([]);
  const [formData, setFormData] = useState({
    titulo: '',
    descricao: '',
    data: '',
    hora_inicio: '',
    hora_fim: '',
    local: '',
    status: 'agendada'
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const aplicarModelo = (modelo) => {
    setFormData(prev => ({
      ...prev,
      titulo: modelo.titulo,
      descricao: modelo.descricao
    }));
  };

  // Carregar colaboradores e cargos
  useEffect(() => {
    const carregarDados = async () => {
      try {
        const [colaboradoresRes, cargosRes] = await Promise.all([
          api.get('/colaboradores'),
          api.get('/cargos')
        ]);
        setColaboradores(colaboradoresRes.data);
        setCargos(cargosRes.data);
      } catch (error) {
        console.error('Erro ao carregar dados:', error);
      } finally {
        setLoadingData(false);
      }
    };

    carregarDados();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      // Criar a reunião
      const reuniaoResponse = await api.post('/reunioes', formData);
      const reuniaoId = reuniaoResponse.data.data.id;

      // Adicionar participantes individuais
      if (participantesSelecionados.length > 0) {
        await api.post(`/reunioes/${reuniaoId}/participantes`, {
          colaboradores_ids: participantesSelecionados
        });
      }

      // Adicionar participantes por cargo
      if (cargosSelecionados.length > 0) {
        await api.post(`/reunioes/${reuniaoId}/participantes-por-cargo`, {
          cargos_ids: cargosSelecionados
        });
      }

      navigate('/reunioes');
    } catch (error) {
      console.error('Erro ao cadastrar reunião:', error);
      const msg =
        error.response?.data?.error ||
        error.message ||
        'Erro ao cadastrar reunião. Tente novamente.';
      alert(msg);
    } finally {
      setLoading(false);
    }
  };

  const adicionarParticipante = (colaboradorId) => {
    if (!participantesSelecionados.includes(colaboradorId)) {
      setParticipantesSelecionados([...participantesSelecionados, colaboradorId]);
    }
  };

  const removerParticipante = (colaboradorId) => {
    setParticipantesSelecionados(participantesSelecionados.filter(id => id !== colaboradorId));
  };

  const adicionarCargo = (cargoId) => {
    if (!cargosSelecionados.includes(cargoId)) {
      setCargosSelecionados([...cargosSelecionados, cargoId]);
    }
  };

  const removerCargo = (cargoId) => {
    setCargosSelecionados(cargosSelecionados.filter(id => id !== cargoId));
  };

  const getColaboradorNome = (id) => {
    const colaborador = colaboradores.find(c => c.id === id);
    return colaborador ? colaborador.nome_completo : '';
  };

  const getCargoNome = (id) => {
    const cargo = cargos.find(c => c.id === id);
    return cargo ? cargo.nome : '';
  };

  return (
    <div className="cadastro-reuniao-page">
      <div className="page-header">
        <button
          onClick={() => navigate('/reunioes')}
          className="btn btn-secondary"
        >
          <FiArrowLeft size={20} />
          Voltar
        </button>
        <h1>Nova Reunião</h1>
      </div>

      <form onSubmit={handleSubmit} className="reuniao-form">
        <div className="form-group modelos-reuniao">
          <label>Modelos predefinidos</label>
          <p className="modelos-hint">Clique em um modelo para preencher título e descrição:</p>
          <div className="modelos-list">
            {MODELOS_PREDEFINIDOS.map((modelo, index) => (
              <button
                key={index}
                type="button"
                className="btn-modelo"
                onClick={() => aplicarModelo(modelo)}
                title={modelo.descricao}
              >
                {modelo.titulo}
              </button>
            ))}
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="titulo">Título *</label>
          <input
            type="text"
            id="titulo"
            name="titulo"
            value={formData.titulo}
            onChange={handleChange}
            required
          />
        </div>

        <div className="form-group">
          <label htmlFor="descricao">Descrição</label>
          <textarea
            id="descricao"
            name="descricao"
            value={formData.descricao}
            onChange={handleChange}
            rows="3"
          />
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="data">Data *</label>
            <input
              type="date"
              id="data"
              name="data"
              value={formData.data}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="status">Status</label>
            <select
              id="status"
              name="status"
              value={formData.status}
              onChange={handleChange}
            >
              <option value="agendada">Agendada</option>
              <option value="em_andamento">Em Andamento</option>
              <option value="concluida">Concluída</option>
              <option value="cancelada">Cancelada</option>
            </select>
          </div>
        </div>

        <div className="form-row">
          <div className="form-group">
            <label htmlFor="hora_inicio">Hora Início *</label>
            <input
              type="time"
              id="hora_inicio"
              name="hora_inicio"
              value={formData.hora_inicio}
              onChange={handleChange}
              required
            />
          </div>

          <div className="form-group">
            <label htmlFor="hora_fim">Hora Fim *</label>
            <input
              type="time"
              id="hora_fim"
              name="hora_fim"
              value={formData.hora_fim}
              onChange={handleChange}
              required
            />
          </div>
        </div>

        <div className="form-group">
          <label htmlFor="local">Local</label>
          <input
            type="text"
            id="local"
            name="local"
            value={formData.local}
            onChange={handleChange}
          />
        </div>

        {/* Seção de Participantes */}
        <div className="participantes-section">
          <h3>Participantes</h3>
          
          {/* Adicionar Colaboradores Individuais */}
          <div className="form-group">
            <label>Adicionar Colaboradores</label>
            <select
              onChange={(e) => {
                if (e.target.value) {
                  adicionarParticipante(parseInt(e.target.value));
                  e.target.value = '';
                }
              }}
              disabled={loadingData}
            >
              <option value="">Selecione um colaborador</option>
              {colaboradores
                .filter(c => !participantesSelecionados.includes(c.id))
                .map(colaborador => (
                  <option key={colaborador.id} value={colaborador.id}>
                    {colaborador.nome_completo} - {colaborador.cargo_nome || 'Sem cargo'}
                  </option>
                ))
              }
            </select>
          </div>

          {/* Lista de Colaboradores Selecionados */}
          {participantesSelecionados.length > 0 && (
            <div className="selected-items">
              <h4>Colaboradores Selecionados:</h4>
              <div className="selected-list">
                {participantesSelecionados.map(id => (
                  <div key={id} className="selected-item">
                    <span>{getColaboradorNome(id)}</span>
                    <button
                      type="button"
                      onClick={() => removerParticipante(id)}
                      className="btn-remove"
                    >
                      <FiX size={16} />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Adicionar por Cargo */}
          <div className="form-group">
            <label>Adicionar por Cargo</label>
            <select
              onChange={(e) => {
                if (e.target.value) {
                  adicionarCargo(parseInt(e.target.value));
                  e.target.value = '';
                }
              }}
              disabled={loadingData}
            >
              <option value="">Selecione um cargo</option>
              {cargos
                .filter(c => !cargosSelecionados.includes(c.id))
                .map(cargo => (
                  <option key={cargo.id} value={cargo.id}>
                    {cargo.nome}
                  </option>
                ))
              }
            </select>
            <small>Todos os colaboradores com este cargo serão adicionados automaticamente</small>
          </div>

          {/* Lista de Cargos Selecionados */}
          {cargosSelecionados.length > 0 && (
            <div className="selected-items">
              <h4>Cargos Selecionados:</h4>
              <div className="selected-list">
                {cargosSelecionados.map(id => (
                  <div key={id} className="selected-item">
                    <span>{getCargoNome(id)}</span>
                    <button
                      type="button"
                      onClick={() => removerCargo(id)}
                      className="btn-remove"
                    >
                      <FiX size={16} />
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>

        <div className="form-actions">
          <button
            type="button"
            onClick={() => navigate('/reunioes')}
            className="btn btn-secondary"
          >
            Cancelar
          </button>
          <button
            type="submit"
            disabled={loading}
            className="btn btn-primary"
          >
            <FiSave size={20} />
            {loading ? 'Salvando...' : 'Salvar'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default CadastroReuniao;